<template>
  <div class="attendance-config">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="configBox">
      <form>
        <div class="form-line" >
          <div class="textBox" style="width: 120px">
<!--            <b class="red">*</b>-->
            <span class="line-text">管理费：</span>
          </div>
          <el-input v-model="configData.managementFee" size="small" style="width: 240px" :disabled="!modifyState" >
            <template slot="append">%</template>
          </el-input>
        </div>

        <div class="form-line">
          <div class="textBox" style="width: 120px">
<!--            <b class="red">*</b>-->
            <span class="line-text">税率：</span>
          </div>
          <el-input v-model="configData.taxRate" size="small" style="width: 240px" :disabled="!modifyState" >
            <template slot="append">%</template>
          </el-input>
        </div>

        <div class="form-line">
          <div class="textBox" style="width: 120px">
<!--            <b class="red">*</b>-->
            <span class="line-text">调休天数配置：</span>
          </div>
          <el-select v-model="configData.restCalculation" size="small" style="width: 240px" :disabled="!modifyState">
            <el-option v-for="item in restCalculationList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>

        <div class="form-line" style="margin-top: 50px;">
          <div class="textBox" style="margin-right: 20px;">
            <b class="red">*</b>
            <span class="line-text">迟到时间不满1小时是否按1小时计算：</span>
          </div>
          <el-switch v-model="configData.lateRulesEnable" active-text="是" :disabled="!modifyState" inactive-text="否"></el-switch>
        </div>

        <div class="form-line">
          <div class="textBox" style="margin-right: 20px;">
            <b class="red">*</b>
            <span class="line-text">早退时间不满1小时是否按1小时计算：</span>
          </div>
          <el-switch v-model="configData.earlyRulesEnable" active-text="是" :disabled="!modifyState" inactive-text="否"></el-switch>
        </div>

        <div class="form-line">
          <div class="textBox" style="margin-right: 20px;">
            <b class="red">*</b>
            <span class="line-text">考勤天数不满0.5天是否按0天计算：</span>
          </div>
          <el-switch v-model="configData.dayCountEnable" active-text="是" :disabled="!modifyState" inactive-text="否"></el-switch>
        </div>



        <div v-if="!modifyState && permissionCodes.indexOf('034020001') !== -1" class="form-btn-box" style="display: flex;justify-content: center;">
          <button-confirm @confirm="modify" value="修改"  />
        </div>
        <div class="form-btn-box" v-if="modifyState && permissionCodes.indexOf('034020001') !== -1">
          <button-confirm @confirm="confirm" />
          <button-cancel @cancel="cancel" />
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { api } from "../../api/AttendancePoint";
import { errorHandler } from "../../../utils/errorHandler";
import { nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";

export default {
  components: {
    ButtonConfirm,
    ButtonCancel,
    Breadcrumb
  },
  name: "attendance-config",
  data() {
    return {
      breadcrumb: [{
        value: '智慧考勤',
        name: 'attendance-department-manage'
      }, {
        value: '考勤配置'
      }],
      permissionCodes: '',
      modifyState: false,
      restCalculationList: [
        {code: '0', name: '累加'},
        {code: '1', name: '清零'},
      ],
      configData: {
        lateRulesEnable: false,
        earlyRulesEnable: false,
        dayCountEnable: false,
        managementFee: '',
        taxRate: '',
        restCalculation: ''
      },
    };
  },
  created() {
    this.getAttendanceConfig();
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    getAttendanceConfig() {
      this.$axios.get(api.getAttendanceConfig, {})
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (data) {
              this.configData = data;
            }
          }
        })
        .catch(errorHandler("查询失败"));
    },
    // 点击修改
    modify() {
      this.modifyState = true;
    },

    // 取消修改
    cancel() {
      this.modifyState = false;
      this.getAttendanceConfig();
    },

    // 修改
    confirm() {
      this.$axios.post(api.saveAttendanceConfig, this.configData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.modifyState = false;
            this.getAttendanceConfig();
          }
        })
        .catch(errorHandler("修改失败"));
    }
  }
};
</script>

<style scoped>
.textBox {
  width: 280px;
}
</style>

<style lang="less">
.attendance-config {
  .configBox {
    margin-top: 60px;
  }
  .el-tabs--top.el-tabs--card .el-tabs__item:last-child {
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/WorkAttendance/AttendanceConfig/AttendanceConfig.vue